import intersection from 'lodash/intersection'
import { getCookie } from './cookies'
import { RouteTemplateProperties } from 'settings/routes/types/RouteTemplateProperties'
import { RouteProperties } from 'settings/routes/types/RouteProperties'
import { isArrayWithLength } from 'utils'
import { COOKIE_NAME } from 'services/api'

/** @deprecated - убрать после того как уйдут из тасктрекера */
export enum Roles {
  ADMIN = 'admin',
  ADMIN_CONTENT = 'admin-content',
  SUPERVISOR = 'supervisor',
  ACCOUNT_MANAGER = 'account-manager',
  SUPPORT_MANAGER = 'SUPPORT_MANAGER',
  AGENCY_PRIME_MANAGER = 'agency-primary-manager',
  AGENCY_MANAGER = 'agency-manager',
  CLIENT_PRIME_MANAGER = 'client-primary-manager',
  CLIENT_MANAGER = 'client-manager',
  GUEST = 'GUEST',
}

export const isLoggedIn = () => {
  return !!getCookie(COOKIE_NAME)
}

export function getAllowedRoutes(routes: RouteTemplateProperties[], tags: string[] = []) {
  return routes.map(({ routes, ...rest }: RouteTemplateProperties) => {
    return {
      routes: routes.filter(({ permission }: RouteProperties) => {
        if (!permission) return true
        else if (!isArrayWithLength(permission)) return true
        else return intersection(permission, tags).length
      }),
      ...rest,
    }
  })
}
